module.exports = __webpack_public_path__ + "img/p5.d55ddf1f.png";